export default __webpack_public_path__ + "static/media/G89A7810_tn.532b841e.jpg";